export const InfoModalTypes = {
    INFO: 'INFO',
    INTERIOR_COMBINATION: 'INTERIOR_COMBINATION',
} as const

export type InfoModalType = typeof InfoModalTypes[keyof typeof InfoModalTypes] | null
